import { TableColumnMeta } from "../../types";

export const getColumnKey = (column: TableColumnMeta) => `thead-column-${column.id}`;
